
export const setDataLocation = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data))
}
export const getDataLocation = (key) => {
        return JSON.parse(localStorage.getItem(key))
}
// 添加防抖函数
export const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};
// 跳转外部链接
export const jumpExternalLink = (url) => {
    
    window.open(url, '_blank');
}